import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import apiClient from "../components/apiClient";
import "@ckeditor/ckeditor5-ui/theme/globals/globals.css";
import "@ckeditor/ckeditor5-theme-lark/theme/theme.css";
import DOMPurify from "dompurify";

export const sanitizeHTML = (html) => ({
  __html: DOMPurify.sanitize(html),
});

const Accordion = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const [shipingDelivery, setShipingDelivery] = useState("");

  useEffect(() => {
    const fetchShipingDelivery = async () => {
      try {
        const response = await apiClient.get("support/shipping");
        if (response.data && response.data.length > 0) {
          setShipingDelivery(response.data[0].shipping);
        }
      } catch (error) {
        console.error("Failed to fetch About Us content:", error);
      }
    };

    fetchShipingDelivery();
  }, []);

  return (
    <>
      <section className="py-20">
        <div className="mt-8 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* <h2 className="text-4xl font-bold text-gray-900 leading-[3.25rem] mb-5 text-center">
            Shipping and Delivery
          </h2>
          <div className="mt-8">
            <h3 className="text-2xl font-semibold text-gray-800 mb-4">
              Shipping Policy
            </h3>
            <p className="text-base text-gray-600 mb-4">
              Orders will be sent within 2 - 3 working days for the Jabodetabek
              area and 4 - 7 working days outside Jabodetabek.
            </p>

            <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
              Delivery Services Available at Musique:
            </h3>
            <ul className="list-disc list-inside text-base text-gray-600 space-y-2">
              <li>JNE</li>
              <li>Music Shop Courier</li>
            </ul>

            <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
              Shipping Schedule
            </h3>
            <p className="text-base text-gray-600 mb-4">
              Monday - Friday: Regular delivery at 15:00 WIB
            </p>
            <p className="text-base text-gray-600 mb-4">
              There are no deliveries on Saturdays, Sundays, and National
              Holidays.
            </p>
            <p className="text-base text-gray-600 mb-4">
              Orders made after the order processing time limit will be
              processed the following day.
            </p>

            <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
              Instant Delivery:
            </h3>
            <p className="text-base text-gray-600 mb-4">
              Instant delivery is carried out based on requests from customers
              by contacting Musique Customer Service on WhatsApp number
              (+62) 821-2121-1509.
            </p>

            <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
              Instant Grab/Gojek Delivery Orders Schedule
            </h3>
            <ul className="list-disc list-inside text-base text-gray-600 space-y-2">
              <li>Monday - Friday: Instant Delivery 10:00 - 15:00 WIB</li>
              <li>
                Saturday, Sunday, and National Holidays delivery is not
                available.
              </li>
              <li>Next Day Delivery 10:00 - 15:00 WIB</li>
              <li>
                Saturday, Sunday, and National Holidays delivery is not
                available.
              </li>
            </ul>
          </div> */}
          {/* <div
            className="ck-content mt-4 whitespace-pre-wrap text-black"
            dangerouslySetInnerHTML={{ __html: shipingDelivery }}
          /> */}
          <div
            className="ql-editor"
            dangerouslySetInnerHTML={{ __html: shipingDelivery }}
          />
        </div>
      </section>
      <Footer></Footer>
    </>
  );
};

export default Accordion;
